export default "__VITE_ASSET__BRQteUgY__"